<template>
    <CommunityPickForm :favorite="favorite" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import CommunityPickForm from './CommunityPickForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    CommunityPickForm
  },
  data() {
    return {
      loaded:false,
      favorite:null
    }
  },
  methods:{
    
  },
  async mounted()
  {
    this.favorite=await APIRequest.detail('favorites',this.$route.params.id)
    this.loaded=true
  }
}
</script>
